







































































import Vue from 'vue';
import SideBar from '@/components/sidebar/SideBar.vue';
import {
  Url,
  SuccessMessage,
  ValidationMessages,
  Routes
} from '@/constants';
import { decryptPlainText, validatePasswords } from '@/util';
import { isSessionValid, postVerificationActions } from './services/service';
import { signIn, verify } from '@/core';

export default Vue.extend({
  components: {
    SideBar,
    SuccessMessage: () => import('@/components/modals/SuccessMessage.vue')
  },
  data () {
    return {
      newPassword: '',
      confirmPassword: '',
      policy: false,
      requiredFields: false,
      errors: [] as string[],
      user: {
        email: '',
        password: ''
      },
      cognitoUser: {} as any,
      privacyPolicy: Url.privacyPolicy,
      termsOfUse: Url.termsOfUse,
      isVerified: false,
      passwordSucessful: SuccessMessage.passwordSet,
      showPassword: {
        newPassword: false,
        confirmPassword: false
      },
      loading: false
    };
  },
  mounted () {
    const email = this.$route.query.email;
    const verificationCode = this.$route.query.verificationCode;
    this.user.email = (email && decryptPlainText(email.toString())) || '';
    this.user.password = (verificationCode && decryptPlainText(verificationCode.toString())) || '';
    this.signInUser(this.user.password, this.checkForNewPassword);
  },
  methods: {
    validate () {
      const { name } = this.cognitoUser.challengeParam.userAttributes;
      const message = validatePasswords(
        this.newPassword,
        this.confirmPassword,
        this.user.email,
        name
      );
      message && this.errors.push(message);
      !this.policy && this.errors.push(ValidationMessages.selectPrivacyAndTerm);
    },

    async submit () {
      !isSessionValid(this.cognitoUser) && await this.signInUser(this.user.password, this.checkForNewPassword)
      const date = new Date();
      this.errors = [];
      this.validate();
      if (!this.errors.length) {
        try {
          this.loading = true;
          await verify(this.cognitoUser, this.newPassword);
          this.handleSuccess(date);
          this.loading = false;
        } catch (error) {
          this.isVerified = false;
          this.loading = false;
        }
      }
    },
    handleSuccess (date: Date) {
      this.isVerified = true;
      this.signInUser(this.newPassword, postVerificationActions, date);
    },
    async signInUser (password: string, callback: Function, date?: Date) {
      try {
        this.loading = true;
        const user = await signIn(this.user.email, password);
        callback(user, date);
        this.loading = false;
      } catch {
        this.loading = false;
        this.$router.push({ name: Routes.SIGNIN });
      }
    },
    checkForNewPassword (user: any) {
      this.cognitoUser = user;
      if (this.cognitoUser.challengeName !== 'NEW_PASSWORD_REQUIRED') {
        this.$router.push({ name: Routes.SIGNIN });
      }
    }
  }
});
